// extracted by mini-css-extract-plugin
module.exports = {"Sections":"sections_Sections__qFjJg","SectionsList":"sections_SectionsList__g8NEA"};